import { createContext, useContext } from "react"
import { Settings } from "schemas"

export const SettingsContext = createContext<Settings>({})

export const useSettings = () => useContext(SettingsContext)

const SettingsContextProvider = ({ settings, children }) => (
  <SettingsContext.Provider value={settings}>
    {children}
  </SettingsContext.Provider>
)

export default SettingsContextProvider
